export interface OverlapSpan {
  start: Date;
  end: Date;
}

/** Max events alive at the same instant (sweep line); merely-touching bookings don't count as overlapping, matching RBC's no-overlap convention. */
export function getMaxSimultaneousOverlap(events: OverlapSpan[]): number {
  if (events.length === 0) {
    return 0;
  }

  const points: Array<[number, number]> = [];
  for (const { start, end } of events) {
    points.push([start.getTime(), 1]);
    points.push([end.getTime(), -1]);
  }
  points.sort((a, b) => a[0] - b[0] || a[1] - b[1]);

  let current = 0;
  let max = 0;
  for (const [, delta] of points) {
    current += delta;
    if (current > max) {
      max = current;
    }
  }
  return max;
}
